import gql from 'graphql-tag'

export const UpdateHomework = gql`
mutation UpdateHomework($id: ID!, $done: Boolean, $comment: String) {
  updateHomework(id: $id,done: $done, comment: $comment) {
    homework {
      id      
    }
  }
}
`

export const DeleteHomework = gql`
mutation DeleteHomework($id: ID!) {
  deleteHomework(id: $id) {
    id_
  }
}
`
